import { css as r } from "@microsoft/fast-element";
import { normalize as e } from "../common/normalize.js";
import { display as l, PropertyStyleSheetBehavior as c } from "@matrix42/fast-foundation";
import { typography as a } from "../styles/typography.js";
import { designTokens as o } from "../design-tokens.js";
function t(i, n) {
  return new c("variant", i, n);
}
const s = r`
  .control,
  .hint-icon {
    /* Style */
    color: ${o.color.neutral[100]};
  }
`, h = r`
  .control,
  .hint-icon {
    /* Style */
    color: ${o.color.warning[100]};
  }
`, y = r`
  .control,
  .hint-icon {
    /* Style */
    color: ${o.color.error[100]};
  }
`, m = r`
  .control,
  .hint-icon {
    /* Style */
    color: ${o.color.primary[100]};
  }
`, f = r`
  ${e}
  ${l("flex")}
  .control {
    /* Layout */
    display: flex;
    gap: ${o.spacing[2]};
    align-items: center;
    /* Typography */
    ${a("p", "regular", !0)}
  }

  :host {
    text-align: left;
  }

  .hint-icon {
    /* Base */
    min-width: var(${o.iconSize.md.cssCustomProperty});
    min-height: var(${o.iconSize.md.cssCustomProperty});
  }
`.withBehaviors(
  t("neutral", s),
  t("warning", h),
  t("error", y),
  t("highlight", m)
);
export {
  f as hintStyles
};
